import styled, { css } from 'styled-components';

export const StyledProductNotesList = styled.div`
  ul {
    padding-right: 20px;
  }
`;

export const StyledNotificationBadge = styled.span`
  display: inline-block;
  margin: 0 5px;

  span {
    color: #333333;
  }
`;

// Controls that read as links but have to be buttons to reach the keyboard.
// The default focus ring is left in place, as on StyledIconButton.
const linkButtonReset = css`
  padding: 0;
  border: none;
  background: none;
  /* inherit the surrounding type rather than the user agent button font */
  font: inherit;
  text-align: inherit;
  cursor: pointer;
`;

// Sits inside the program cell text flow, so it stays inline.
export const StyledInlineLink = styled.button.attrs({ type: 'button' })`
  ${linkButtonReset}
  text-decoration: none;
  /* These were anchors styled by the global a rule, which a button does not
     match, so that typography is restated here. */
  color: #1e79c2;
  line-height: 1.5;
  font-weight: 400;
  vertical-align: baseline;

  /* drops to the surrounding body colour once it cannot be clicked */
  &:disabled {
    color: ${({ theme }) => theme.colors.neutral['700']};
    cursor: default;
  }
`;

export const StyledGuidelinesLink = styled(StyledInlineLink)`
  padding-left: 5px;
  color: #006aa9;
`;

// Rate and Guidelines use one blue, details and the Show More control a darker
// one.
// The grid scrolls inside its own container so block virtualisation has a
// viewport to measure against.
export const StyledGridScroll = styled.div`
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
`;

// Icons sit on the program name line, aligned to the right of the column.
export const StyledProgramIcons = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

// The global p rule sized these as paragraphs, which is why the target row
// keeps a light rate and details against its bold values.
const paragraphCompat = css`
  font-size: 1rem;
  line-height: normal;
  font-weight: 400;
`;

export const StyledGridLink = styled.button.attrs({ type: 'button' })`
  ${linkButtonReset}
  ${paragraphCompat}
  margin: 0;
  color: #006aa9;
  text-decoration: underline;
`;

export const StyledGridDetailsLink = styled(StyledGridLink)`
  color: #005181;
`;

export const StyledShowMoreControl = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 8px;
  border: none;
  background: none;
  cursor: pointer;
  color: #005181;
  font-size: 12px;
  font-weight: 600;
`;

export const StyledIconButton = styled.button`
  border: none;
  background: none;
  padding: 0;
  cursor: pointer;
  line-height: 0;
`;

// Sits above the filter pills.
export const StyledAvailableProgramsHeading = styled.h2`
  margin: 0;
  padding: 10px 0;
  font-size: 15px;
  font-weight: 600;
  color: #000000;
`;

// For cell values that are words rather than numbers, so they wrap inside a
// column sized for figures.
// Keeps a value flush right whether or not an icon precedes it, so a marker on
// one row cannot shift that row out of line with the rest of the column.
export const StyledIconThenValue = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;

  > :last-child {
    margin-left: auto;
  }
`;
